import React, {useState} from "react";
import HomeBanner from "../components/MainBanner";
import StudentHighlight from "../components/StudentHighlight";
import WelcomeSection from "../components/WelcomeSection";
import WhyStudents from "../components/WhyStudents";
import ClassesSection from "../components/ClassesSection";
import CourseDetails from "../components/CourseDetails";
import ClassOffers from "../components/ClassOffers";
import FreeTrialSection from "../components/FreeTrialSection";
import FAQ from "../components/FAQ";
import Popup from "../components/Popup";
import WebinarFormPopup from "../components/WebinarFormPopup";
import { FaVideo, FaTools, FaInfinity, FaBriefcase } from "react-icons/fa";
import MainBanner from "../components/MainBanner";
import CourseCard from "../components/CourseCard";
import Fivebox from './../components/Fivebox';
import RoleCards from './../components/RoleCards';


function Home() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };

  const courseData = {
  highlights: [
{ icon: <FaVideo />, text: "350+ Live sessions" },
  { icon: <FaTools />, text: "15+ Industry Projects" },
  { icon: <FaInfinity />, text: "Lifetime accessibility" },
  { icon: <FaBriefcase />, text: "Live project experience" },
  ],
  title: "Basic Level: Spoken English Course Content",
  description:
    "This course is designed for individuals who can read and write English but lack confidence and fluency in speaking. The focus is on practical communication skills and real-world application.",
  // price: "120,000",
  emi: "5,900",
  applyLink: "#apply",

  batchDate: { day: "19", month: "AUG", batch: "Morning" },
  batchName: "Next Advanced Level: Spoken English",
  batchDays: "Sat - Sun",
  batchTime: "09:00 am - 12:00 pm",
  batchSeat: "Available",
  batchVenue: "Virtual Hall",
  enrollLink: "#enroll",
};

const faqData = [
  {
    question: '1. Which Spoken English level should I join – Beginner, Intermediate, or Advanced?',
    answer: <>
    <ul>
      <li><b>Beginner:</b> This level is for learners who are comfortable with reading and writing in English but face challenges when speaking, even with short sentences of 4 to 5 words. The program builds a strong foundation in basic communication skills, pronunciation, and everyday vocabulary, helping participants gain the confidence to start speaking English naturally in real-life situations.</li>
      <li><b>Intermediate:</b> This level is designed for learners who can form simple sentences but struggle to speak fluently for more than a minute. The program focuses on developing greater confidence, fluency, and clarity, enabling participants to communicate more effectively and carry out their professional responsibilities with ease.</li>
      <li><b>	Advanced:</b> This program is tailored for professionals who already speak English with confidence but seek to enhance their language skills to meet the demands of their careers. It is ideal for teachers, trainers, executives, lawyers, doctors, hospitality professionals, and others whose roles require advanced communication. The focus is on refined pronunciation, enriched vocabulary, effective global customer engagement, professional communication across all levels of corporate hierarchy, and confident participation in meetings, presentations, and official interactions.</li>
      <li><b>TOEFL/IELTS Preparation:</b> This program is tailored for professionals who already speak English with confidence but seek to enhance their language skills to meet the demands of their careers. It is ideal for teachers, trainers, executives, lawyers, doctors, hospitality professionals, and others whose roles require advanced communication. The focus is on refined pronunciation, enriched vocabulary, effective global customer engagement, professional communication across all levels of corporate hierarchy, and confident participation in meetings, presentations, and official interactions.</li>
    </ul>
    </>
  },
  {
    question: '2. How long are the courses?',
    answer: <>
    Each level runs for 3–6 weeks depending on the course.
    <ul>
      <li>Beginner – 3 weeks</li>
<li>Intermediate – 6 weeks</li>
<li>	Advanced – customized for the group – can be anything between 4 weeks to 8 weeks
</li>
    </ul>
    
    </>
  },
  {
    question: '3. Can I skip Beginner and start directly with Intermediate or Advanced?',
    answer: 'Yes! We conduct a free level assessment test before you join, so you’ll be placed in the right level based on your current skills.'
  },
  {
    question: '4. What is the teaching method used in your classes?',
    answer:  <>Our training is practical and interactive. Instead of memorizing grammar. We focus on: <ul>
      <li>Real-life conversations</li>
<li>Vocabulary building exercises</li>
<li>Pronunciation practice
</li>
<li>Confidence-building exercises: 1- or 2-minute speech, impromptu speech, story building, etc</li>
    </ul></>
  },
  {
    question: '5. Do you provide study materials?',
    answer: 'Yes. Your teacher will coordinate on this.'
  },
  {
    question: '6. What will I learn in each level?',
    answer: <>  <ul>
      <li><b>Beginner:</b> Basic grammar, everyday vocabulary, self-introduction, asking/answering questions.</li>
      <li><b>Intermediate:</b> Storytelling, polite conversation, workplace English, correcting common mistakes.</li>
      <li><b>	Advanced:</b> Public speaking, debates, professional writing & presentation skills, accent refinement.</li>
      <li><b>TOEFL/IELTS Preparation:</b> This program is designed for students and professionals aiming to excel in international English proficiency exams. It focuses on all four modules—Listening, Reading, Writing, and Speaking</li>
    </ul></>
  },
  {
    question: '7. Will I become fluent after completing the course?',
    answer: 'Fluency depends on practice outside class too. We give you the tools, strategies, and daily speaking practice to improve rapidly. Students who practice regularly notice big changes within weeks.'
  },
  {
    question: '8. Do you offer both online and offline classes?',
    answer: 'No.  We offer only online classes'
  },
    {
    question: '9. What is the batch size?',
    answer: 'We keep our batches small, maximum 20 students per batch, so that everyone gets personal attention and speaking time.'
  },
    {
    question: '10. How do I enroll?',
    answer: <>Register on our website www.newzealacademy.com You may call/whatsapp +91 63607 05213 if you have any questions, 
    our team will guide you to the right level and schedule. <br/><br/> <a href="/enroll-for-course" className="join-btn" style={{textDecoration: "none"}}>Enroll Now</a> </>
  }
];


  return (
    <>
    <MainBanner />
    {/* <StudentHighlight /> */}
      <h1 style={{textAlign: "center"}}>"OUR GOAL: Practical English for Real-life Situations."</h1>
      <RoleCards/>
    <WelcomeSection />
     <WhyStudents />
    <Fivebox/>
 

   
    <ClassesSection />
    {/* <CourseDetails
  highlights={courseData.highlights}
  title={courseData.title}
  description={courseData.description}
  // price={courseData.price}
  emi={courseData.emi}
  applyLink={courseData.applyLink}
  batchDate={courseData.batchDate}
  batchName={courseData.batchName}
  batchDays={courseData.batchDays}
  batchTime={courseData.batchTime}
  batchSeat={courseData.batchSeat}
  batchVenue={courseData.batchVenue}
  enrollLink={courseData.enrollLink}
   openPopup={openPopup} 
/> */}
{/* <FreeTrialSection /> */}
<FAQ data={faqData} />
<Popup isOpen={isPopupOpen} onClose={closePopup}>
  <WebinarFormPopup onClose={closePopup} />
</Popup>


    </>
  );
}

export default Home;
